import { render, staticRenderFns } from "./edit_showroom.vue?vue&type=template&id=b2ba41ac&"
import script from "./edit_showroom.vue?vue&type=script&lang=js&"
export * from "./edit_showroom.vue?vue&type=script&lang=js&"
import style0 from "./edit_showroom.vue?vue&type=style&index=0&id=b2ba41ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports